import { useQuery } from 'react-query';
import * as storageService from 'services/storage.service';
import userService from 'resources/user/user.service';

const getCompanyUsers = async (companyId) => {
  let users = await userService.getCompanyUsers(companyId) || [];

  users = await Promise.all(
    users.map(async (user) => {
      if (!user.avatar_url) {
        return user;
      }

      const avatarUrl = await storageService.getAvatarUrl(user.avatar_url);

      return {
        ...user,
        avatar_id: user.avatar_url,
        avatar_url: avatarUrl,
      };
    })
  );

  return users;
};

export default function useGetCompanyUsers(companyId, queryOptions) {
  return useQuery(
    ['users.companyUsers', companyId],
    () => getCompanyUsers(companyId),
    queryOptions,
  );
}
